import React from 'react';
import { assetUrl } from '../../../../utils/webConfig';
import { Button } from '../../../../components';

const removePictureUrl = assetUrl('/images/svg/remove-profile-img.svg?v=1');
const editProfilePictureUrl = assetUrl('/images/svg/edit-profile-image-icon.svg');

interface AvatarUploaderProps {
    picture: string | undefined;
    tempPicture: string | null;
    fileInputRef: React.RefObject<HTMLInputElement>;
    onFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    imageReset: () => void;
    handleClickChooseFile: () => void;
    handleError: () => void;
}

export const AvatarUploader: React.FC<AvatarUploaderProps> = ({
    picture,
    tempPicture,
    fileInputRef,
    onFileChange,
    imageReset,
    handleClickChooseFile,
    handleError,
}) => {
    const displaySrc =
        !tempPicture && typeof picture === 'string'
            ? assetUrl(picture)
            : (picture as string);

    return (
        <div data-testid="avatar-uploader" className="flex items-center gap-6">
            <div data-testid="avatar-wrapper" className="relative inline-block">
                <div className="rounded-full h-[86px] w-[86px] overflow-hidden inline-block">
                    <img
                        data-testid="avatar-image"
                        src={displaySrc}
                        alt=""
                        onError={handleError}
                        className="w-full h-full object-cover"
                    />
                </div>
                {tempPicture ? (
                    <button
                        data-testid="avatar-remove-button"
                        type="button"
                        className="border-none bg-[#715aff] inline-block h-8 w-8 absolute right-0 bottom-0 text-center rounded-full p-[6px]"
                        onClick={imageReset}
                    >
                        <img alt="remove" src={removePictureUrl} />
                    </button>
                ) : (
                    <button
                        data-testid="avatar-edit-button"
                        type="button"
                        className="border-none bg-[#715aff] inline-block h-8 w-8 absolute right-0 bottom-0 text-center rounded-full p-[6px]"
                        onClick={handleClickChooseFile}
                    >
                        <img alt="edit" src={editProfilePictureUrl} />
                    </button>
                )}
            </div>
            <input
                data-testid="avatar-file-input"
                ref={fileInputRef}
                type="file"
                accept="image/jpeg,image/png"
                className="hidden"
                onChange={onFileChange}
            />
            <Button
                data-testid="avatar-update-link"
                type="button"
                variant="link"
                onClick={handleClickChooseFile}
            >
                Update Profile Picture
            </Button>
        </div>
    );
};
